<script>
import baseMixin from '@/mixins/baseMixin'

export default {
  name: 'TimesheetExpPanelsSkeletonLoader',
  mixins: [baseMixin],
}
</script>

<template>
  <v-skeleton-loader
    loading
    type="timesheet-exp-panel-group-with-divder@4, timesheet-exp-panel-group"
    :types="{
      'timesheet-exp-panel-group-with-divder':
        'timesheet-exp-panel-group, divider',
      'timesheet-exp-panel-group': 'timesheet-exp-panel-header, expand-icon',
      'timesheet-exp-panel-header': 'group-name, group-statistic',
      'group-name': 'heading',
      'group-statistic': 'single-stat@3',
      'single-stat': 'avatar, text',
      'expand-icon': 'avatar',
    }"
    class="timesheet-skeleton-exp-panel"
  />
</template>

<style lang="scss" scoped>
@import '@styles';
::v-deep.timesheet-skeleton-exp-panel.v-skeleton-loader--is-loading {
  .v-skeleton-loader__timesheet-exp-panel-group {
    display: flex;
    align-items: center;
    width: 100%;
    padding: 16px 24px;
  }

  .v-skeleton-loader__timesheet-exp-panel-header {
    display: inline-flex;
    flex-grow: 1;
  }

  .v-skeleton-loader__group-name {
    flex: 0 0 75%;
  }

  .v-skeleton-loader__group-statistic {
    display: block;
    flex: 0 0 25%;
    align-items: center;
  }

  .v-skeleton-loader__single-stat {
    display: inline-flex;

    .v-skeleton-loader__avatar {
      width: 16px;
      height: 16px;
      margin-right: 8px;
    }
    .v-skeleton-loader__text {
      width: 30px;
      height: 16px;
      margin-right: 20px;
      margin-bottom: 0;
    }
  }

  .v-skeleton-loader__expand-icon {
    display: inline-flex;
    align-items: center;
    float: right;

    .v-skeleton-loader__avatar {
      width: 24px;
      height: 24px;
    }
  }
}
</style>
